try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
var Skeleton = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    height = _ref.height,
    width = _ref.width;
  return jsx("div", {
    ref: ref,
    style: {
      height: height,
      width: width
    },
    "data-testid": "skeleton-block",
    className: classNames('cds-skeleton', className)
  });
});
export { Skeleton };